import { Role } from "../../types/role";

const KFVun: Role = {
  primary: [
    "Ballannahme",
    "Dribbling",
    "Flanken",
    "Passen",
    "Technik",
    "Einsatzfreude",
    "Entscheidungen",
    "OhneBall",
    "Teamwork",
    "Antritt",
    "Ausdauer",
    "Schnelligkeit",
  ],
  secondary: [
    "Tackling",
    "Antizipation",
    "Flair",
    "Nervenstaerke",
    "Balance",
    "Beweglichkeit",
  ],
  physis: "abwehr",
};

const KFVan: Role = {
  primary: [
    "Ballannahme",
    "Dribbling",
    "Flanken",
    "Passen",
    "Technik",
    "Einsatzfreude",
    "Entscheidungen",
    "Flair",
    "OhneBall",
    "Teamwork",
    "Antritt",
    "Ausdauer",
    "Schnelligkeit",
  ],
  secondary: [
    "Tackling",
    "Antizipation",
    "Nervenstaerke",
    "Balance",
    "Beweglichkeit",
  ],
  physis: "abwehr",
};

export const KFV = {
  KFVun,
  KFVan,
};
